<template>
  <div
    class="add-to-mail"
    :class="{ disabled, 'is-deleted': isDeleted }"
    :title="disabled ? title : ''"
    @click="handleClick"
  >添加到待邮寄</div>
</template>
<script>
export default {
  name: "mail-list-operation",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    isDeleted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
.add-to-mail {
  font-size: 12px;
  color: #0077FF;
  text-align: center;
  cursor: pointer;
  user-select: none;
  &:hover {
    text-decoration: underline;
    color: #CC0000;
  }
  &.disabled {
    cursor: not-allowed;
    &:hover {
      text-decoration: none;
    }
  }
  // 已删除状态：显示删除线
  &.is-deleted {
    color: #333333;
    text-decoration: line-through;
    &:hover {
      color: #333333;
    }
  }
  // 其他禁用状态（审核中/数量不足）：置灰不划线
  &.disabled:not(.is-deleted) {
    color: #cccccc;
    &:hover {
      color: #cccccc;
    }
  }
}
</style>